import { BaseApi } from "./baseService";
import { Injectable } from "@angular/core";
import { Headers, Http, RequestMethod, RequestOptions, ResponseContentType, URLSearchParams } from "@angular/http";
import { ReportSearchRequest } from "../objects/requests/reportSearchRequest";
import { BaseResponse } from "../objects/common/baseResponse";
import { TotalFeeResponse } from "../objects/report/totalFeeResponse";
import { RNSStatusReportRequest } from '../objects/requests/RNSStatusReportRequest';
import { RNSStatusReportResponse } from '../objects/report/RNSStatusReportResponse';
import { SearchResponse } from '../objects/responses/searchResponse';
import { Cookie } from 'ng2-cookies';
import { ConfigService } from './configService';

/**
 * Created by alex.y on 9/20/2017.
 */
@Injectable()
export class ReportService extends BaseApi {
    constructor(protected http: Http, protected configService: ConfigService) {
        super(http, configService);
    }

    public getTotalFee(searchRequest: ReportSearchRequest) : Promise<BaseResponse<Array<TotalFeeResponse>>>{
        return this.post(new RequestOptions({
            url: `report`,
            body: searchRequest
        }));
    }

    public getRNSStatusReport(searchRequest: RNSStatusReportRequest) : Promise<BaseResponse<SearchResponse<RNSStatusReportResponse>>>{
        return this.post(new RequestOptions({
            url: `report/rns/status`,
            body: searchRequest
        }));
    }

    public downloadRNSStatusReport(searchRequest: RNSStatusReportRequest) : Promise<any>{
        let params = new RequestOptions();

        params.headers = new Headers();
        params.headers.append("Content-Type", 'application/json');
        params.headers.append("Authorization", `Bearer ` + Cookie.get(this.config.ApiTokenCookieName));

        params.method = RequestMethod.Get;

        params.url = `${this.config.ApiUrl}/report/export/rns/status`;
        params.params = new URLSearchParams();

        params.responseType = ResponseContentType.Blob;
        return this.http.post(params.url,searchRequest, params).toPromise().then((res: any) => {
            let url = window.URL.createObjectURL(res.blob());

            let link = document.createElement('a');
            link.download = 'RNSStatusData.csv';
            link.href = url;
            link.click();

            window.URL.revokeObjectURL(url);

            return new Promise((resolve, reject) => resolve(true));
        });
    }
}






// WEBPACK FOOTER //
// ./app/services/reportService.ts